"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayoutConfig = void 0;
const helpers_1 = require("../../shared/helpers");
const getLayoutConfig = (stimulus, translations, mediaAssets, trialNumber) => {
    const { answer, distractors, trialType } = stimulus;
    const defaultConfig = JSON.parse(JSON.stringify(helpers_1.DEFAULT_LAYOUT_CONFIG));
    const stimItem = (0, helpers_1.convertItemToString)(stimulus.item);
    defaultConfig.isPracticeTrial = stimulus.assessmentStage === 'practice_response';
    defaultConfig.isInstructionTrial = stimulus.trialType === 'instructions';
    defaultConfig.showStimImage = false;
    defaultConfig.stimText = {
        value: stimItem,
        displayValue: undefined,
    };
    defaultConfig.classOverrides.buttonClassList = ['secondary--wide'];
    defaultConfig.isStaggered = true;
    const mappedDistractors = (0, helpers_1.mapDistractorsToString)(distractors);
    defaultConfig.prompt.enabled = true;
    defaultConfig.isImageButtonResponse = false;
    defaultConfig.response = {
        target: '',
        displayValues: mappedDistractors,
        values: mappedDistractors,
        targetIndex: 0,
    };
    const messages = (0, helpers_1.validateLayoutConfig)(defaultConfig, mediaAssets, translations, stimulus);
    return {
        itemConfig: defaultConfig,
        errorMessages: messages,
    };
};
exports.getLayoutConfig = getLayoutConfig;
